import { ReportType } from '@map/enums';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { Report } from 'src/app/report/models';
import { updateState, withDevtools, withDevToolsStub } from '@angular-architects/ngrx-toolkit';
import { environment } from 'src/environments/environment';

type ReportState = {
    selected: Report | null;
    preview: Report | null;
    loading: boolean;
    loaded: boolean;
};

const initialState: ReportState = {
    selected: null,
    preview: null,
    loading: false,
    loaded: false,
};

export const withTreeShakableDevTools = environment.production ? withDevToolsStub : withDevtools;

export const ReportStore = signalStore(
    { providedIn: 'root' },
    withTreeShakableDevTools('reports'),
    withEntities<Report>(),
    withState<ReportState>(initialState),
    withMethods((store) => ({
        select: (report: Report) => {
            updateState(store, '[Report] Select', { selected: report });
            return report;
        },
        setPreview: (report: Report) => {
            updateState(store, '[Report] Set Preview', { preview: report });
            return report;
        },
        deselect: () => {
            updateState(store, '[Report] Deselect', { selected: null });
        },
        clearPreview: () => {
            updateState(store, '[Report] Clear Preview', { preview: null });
        },
    }))
);
